module.exports = __webpack_public_path__ + "static/media/tokenlist.b58200ac.svg";